exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".incident-form dl {\n\tmargin-bottom: 0;\n}\n\n.incident-form dt {\n\tfont-weight: 600;\n}\n\n.incident-form dd {\n\tfont-size: 20px;\n\tfont-weight: 200;\n}\n", ""]);

// exports
